export default __webpack_public_path__ + "static/logos-tiles-ws-3ee1037691eb763a15fe682d39ae62f5.svg";